<template>
	<div class="w-100 bg-white fit-to-screen">
		<div v-if="is_load" class="py-5">
			<loader /> 
		</div>
		<template v-else> 
			<div v-if="error != ''" class="row justify-content-center">
				<div class="col-4">
					<ErrorMessage :message="error" />
				</div>
			</div>
			<template v-else>
				<div class="w-100" id="ota-header"></div>
				<!-- NAVBAR -->
				<header class="position-sticky top-0 bg-white" :class="{'z-index-1040': backdrop_for != 'cr_lang'}">
					<div class="w-100 position-relative">
						<div class="px-7">
							<div class="row py-1">
								<div class="col-2 align-self-center py-1">
									<img :src="community.image_url" alt="Logo" class="w-auto" height="52">
								</div>
								<div class="col-8 align-self-center text-center">
									<div class="w-100 mobile-none" v-if="!show_filter_top">
										<div class="d-table no-ws mx-auto pl-3 bg-white border-semi-grey rounded-4 mx-2 box-shadow-ota-2">
											<div class="d-inline-block align-middle" @click="toggleBackdrop('merchant')">
												<div class="d-inline-block align-middle mr-3">
													<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 10.3178C3.5 5.71789 7.34388 2 11.9934 2C16.6561 2 20.5 5.71789 20.5 10.3178C20.5 12.6357 19.657 14.7876 18.2695 16.6116C16.7388 18.6235 14.8522 20.3765 12.7285 21.7524C12.2425 22.0704 11.8039 22.0944 11.2704 21.7524C9.13474 20.3765 7.24809 18.6235 5.7305 16.6116C4.34198 14.7876 3.5 12.6357 3.5 10.3178ZM9.19423 10.5768C9.19423 12.1177 10.4517 13.3297 11.9934 13.3297C13.5362 13.3297 14.8058 12.1177 14.8058 10.5768C14.8058 9.0478 13.5362 7.77683 11.9934 7.77683C10.4517 7.77683 9.19423 9.0478 9.19423 10.5768Z" fill="#999999"/>
													</svg>
												</div>
												<p class="mb-0 body-2-4 cursor-pointer d-inline-block align-middle mw-8">All Property</p>
											</div>
											<div class="d-inline-block align-middle custom-divider"></div>
											<div class="d-inline-block align-middle" @click="toggleBackdrop('date')">
												<div class="d-inline-block align-middle mr-3">
													<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path fill-rule="evenodd" clip-rule="evenodd" d="M16.4109 2.76862L16.4119 3.51824C19.1665 3.73413 20.9862 5.61119 20.9891 8.48975L21 16.9155C21.0039 20.054 19.0322 21.985 15.8718 21.99L8.15188 22C5.01119 22.004 3.01482 20.027 3.01087 16.8795L3.00001 8.55272C2.99606 5.65517 4.75153 3.78311 7.50617 3.53024L7.50518 2.78061C7.5042 2.34083 7.83001 2.01 8.26444 2.01C8.69886 2.009 9.02468 2.33883 9.02567 2.77861L9.02666 3.47826L14.8914 3.47027L14.8904 2.77062C14.8894 2.33084 15.2152 2.001 15.6497 2C16.0742 1.999 16.4099 2.32884 16.4109 2.76862ZM4.52148 8.86157L19.4696 8.84158V8.49175C19.4272 6.34283 18.349 5.21539 16.4138 5.04748L16.4148 5.81709C16.4148 6.24688 16.0801 6.5877 15.6556 6.5877C15.2212 6.5887 14.8943 6.24887 14.8943 5.81909L14.8934 5.0095L9.02863 5.01749L9.02962 5.82609C9.02962 6.25687 8.70479 6.5967 8.27036 6.5967C7.83594 6.5977 7.50913 6.25887 7.50913 5.82809L7.50815 5.05847C5.58286 5.25137 4.51753 6.38281 4.52049 8.55072L4.52148 8.86157ZM15.2399 13.4043V13.4153C15.2498 13.8751 15.625 14.2239 16.0801 14.2139C16.5244 14.2029 16.8789 13.8221 16.869 13.3623C16.8483 12.9225 16.4918 12.5637 16.0485 12.5647C15.5944 12.5747 15.2389 12.9445 15.2399 13.4043ZM16.0554 17.892C15.6013 17.882 15.235 17.5032 15.234 17.0435C15.2241 16.5837 15.5884 16.2029 16.0426 16.1919H16.0525C16.5165 16.1919 16.8927 16.5707 16.8927 17.0405C16.8937 17.5102 16.5185 17.891 16.0554 17.892ZM11.1721 13.4203C11.1919 13.8801 11.568 14.2389 12.0222 14.2189C12.4665 14.1979 12.821 13.8181 12.8012 13.3583C12.7903 12.9085 12.425 12.5587 11.9807 12.5597C11.5266 12.5797 11.1711 12.9605 11.1721 13.4203ZM12.0262 17.8471C11.572 17.8671 11.1968 17.5082 11.1761 17.0485C11.1761 16.5887 11.5305 16.2089 11.9847 16.1879C12.429 16.1869 12.7953 16.5367 12.8052 16.9855C12.8259 17.4463 12.4705 17.8261 12.0262 17.8471ZM7.10433 13.4553C7.12408 13.915 7.50025 14.2749 7.95442 14.2539C8.39872 14.2339 8.75317 13.8531 8.73243 13.3933C8.72256 12.9435 8.35725 12.5937 7.91196 12.5947C7.45779 12.6147 7.10334 12.9955 7.10433 13.4553ZM7.95837 17.8521C7.5042 17.8731 7.12901 17.5132 7.10828 17.0535C7.10729 16.5937 7.46273 16.2129 7.9169 16.1929C8.3612 16.1919 8.7275 16.5417 8.73737 16.9915C8.7581 17.4513 8.40365 17.8321 7.95837 17.8521Z" fill="#999999"/>
													</svg>
												</div>
												<p class="mb-0 body-2-4 cursor-pointer d-inline-block align-middle mw-8">{{ $formatDateRange(filter_data.basic.check_in_date,filter_data.basic.check_out_date,'YYYY-MM-DD','YYYY-MM-DD') }}</p>
											</div>
											<div class="d-inline-block align-middle custom-divider"></div>
											<div class="d-inline-block align-middle" @click="toggleBackdrop('guest')">
												<div class="d-inline-block align-middle mr-3">
													<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path fill-rule="evenodd" clip-rule="evenodd" d="M14.7597 7.76241C14.7597 10.4062 12.5963 12.5248 9.8967 12.5248C7.19806 12.5248 5.03367 10.4062 5.03367 7.76241C5.03367 5.11865 7.19806 3 9.8967 3C12.5963 3 14.7597 5.11865 14.7597 7.76241ZM2.54736 17.9174C2.54736 15.47 5.93289 14.8577 9.8967 14.8577C13.882 14.8577 17.246 15.4911 17.246 17.9404C17.246 20.3877 13.8605 21 9.8967 21C5.91136 21 2.54736 20.3666 2.54736 17.9174ZM16.7208 7.84875C16.7208 9.19506 16.3079 10.4513 15.5838 11.4948C15.5085 11.6021 15.575 11.7468 15.7061 11.7698C15.8881 11.7995 16.075 11.8177 16.2658 11.8216C18.164 11.8704 19.8676 10.6736 20.3382 8.87118C21.0359 6.19676 18.9889 3.79543 16.3813 3.79543C16.0985 3.79543 15.8274 3.82418 15.5632 3.87688C15.527 3.88454 15.4879 3.90179 15.4683 3.93246C15.4429 3.97174 15.4615 4.02253 15.4869 4.05607C16.2707 5.13216 16.7208 6.44206 16.7208 7.84875ZM19.8646 13.7023C21.1406 13.9466 21.9791 14.444 22.3265 15.1694C22.621 15.7635 22.621 16.4534 22.3265 17.0475C21.7952 18.1705 20.0809 18.5318 19.4145 18.6247C19.2766 18.6439 19.166 18.5289 19.1807 18.3928C19.5212 15.2805 16.8137 13.8048 16.1131 13.4656C16.0838 13.4493 16.0769 13.4263 16.0799 13.411C16.0818 13.4014 16.0946 13.3861 16.1171 13.3832C17.6327 13.3545 19.2629 13.5586 19.8646 13.7023Z" fill="#999999"/>
													</svg>
												</div>
												<p class="mb-0 body-2-4 cursor-pointer d-inline-block align-middle mw-8">{{ total_guests }}</p>
											</div>
											<div class="d-inline-block align-middle custom-divider mr-2"></div>
											<div class="d-inline-block align-middle bg-primary-ota rounded-4 cursor-pointer py-2 px-3 mr-2" @click="toggleBackdrop('search-hit')">
												<svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
													<circle cx="7.84442" cy="7.84442" r="5.99237" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
													<path d="M12.0122 12.3235L14.3616 14.6667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
												</svg>
											</div>
										</div>
									</div>
									<div v-else class="w-100 mobile-none py-2">
										<p class="heading-6-1 mb-0">Find Your Dream Stay</p>
									</div>
								</div>
								<div class="col-2 align-self-center text-right py-3">
									<!-- <div class="mobile-none">
										<div class="d-inline-block ml-4 cursor-pointer" @click="toggleBackdrop('cr_lang')">
											<svg width="24" height="24" class="mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12ZM15.9698 7.99994H18.9198C17.9598 6.34994 16.4298 5.06994 14.5898 4.43994C15.1898 5.54994 15.6498 6.74994 15.9698 7.99994ZM11.9998 4.04004C12.8298 5.24004 13.4798 6.57004 13.9098 8.00004H10.0898C10.5198 6.57004 11.1698 5.24004 11.9998 4.04004ZM4 12C4 12.69 4.1 13.36 4.26 14H7.64C7.56 13.34 7.5 12.68 7.5 12C7.5 11.32 7.56 10.66 7.64 9.99997H4.26C4.1 10.64 4 11.31 4 12ZM5.08008 16.0001H8.03008C8.35008 17.2501 8.81008 18.4501 9.41008 19.5601C7.57008 18.9301 6.04008 17.6601 5.08008 16.0001ZM5.08008 7.99999H8.03008C8.35008 6.74999 8.81008 5.54999 9.41008 4.43999C7.57008 5.06999 6.04008 6.33999 5.08008 7.99999ZM11.9998 19.96C11.1698 18.76 10.5198 17.43 10.0898 16H13.9098C13.4798 17.43 12.8298 18.76 11.9998 19.96ZM9.66 14H14.34C14.43 13.34 14.5 12.68 14.5 12C14.5 11.32 14.43 10.65 14.34 9.99997H9.66C9.57 10.65 9.5 11.32 9.5 12C9.5 12.68 9.57 13.34 9.66 14ZM14.5898 19.56C15.1898 18.45 15.6498 17.25 15.9698 16H18.9198C17.9598 17.65 16.4298 18.93 14.5898 19.56ZM16.5004 12C16.5004 12.68 16.4404 13.34 16.3604 14H19.7404C19.9004 13.36 20.0004 12.69 20.0004 12C20.0004 11.31 19.9004 10.64 19.7404 10H16.3604C16.4404 10.66 16.5004 11.32 16.5004 12Z" fill="#222222" fill-opacity="0.7"/>
											</svg>
											<p class="mb-0 font-semibold text-16 text-color-dark d-inline-block"><span>{{$t('hotel.language')}}</span> | {{getCurrency.code}}</p>
										</div>
										<div class="d-inline-block ml-4">
											<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path fill-rule="evenodd" clip-rule="evenodd" d="M11.9849 15.3462C8.11731 15.3462 4.81445 15.931 4.81445 18.2729C4.81445 20.6148 8.09636 21.2205 11.9849 21.2205C15.8525 21.2205 19.1545 20.6348 19.1545 18.2938C19.1545 15.9529 15.8735 15.3462 11.9849 15.3462Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
												<path fill-rule="evenodd" clip-rule="evenodd" d="M11.9849 12.0059C14.523 12.0059 16.5801 9.94779 16.5801 7.40969C16.5801 4.8716 14.523 2.81445 11.9849 2.81445C9.44679 2.81445 7.3887 4.8716 7.3887 7.40969C7.38013 9.93922 9.42394 11.9973 11.9525 12.0059H11.9849Z" stroke="#222222" stroke-width="1.42857" stroke-linecap="round" stroke-linejoin="round"/>
											</svg>
											<p class="mb-0 font-semibold text-16 text-color-dark d-inline-block">Login</p>
										</div>
									</div> -->
									<div class="cursor-pointer" @click="toggleMobileHeader()">
										<div class="hamburger float-right" :class="{'top-9px':responsive.mobile_header}">
											<div class="one" :class="{'one-active':responsive.mobile_header}"></div>
											<div class="two" :class="{'two-active':responsive.mobile_header}"></div>
											<div class="three" :class="{'d-none':responsive.mobile_header}"></div>
										</div>
									</div>
								</div>
								<div class="col-12 mt-2 desktop-none" v-if="!responsive.mobile_header">
									<div class="w-100 bg-white border-semi-grey rounded-4 box-shadow-ota-2">
										<div class="row no-gutters">
											<div class="col-2 text-center">
												<div class="py-3">
													<svg style="top:-3px" class="position-relative" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
														<circle cx="7.84442" cy="7.84442" r="5.99237" stroke="#959DAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
														<path d="M12.0122 12.3235L14.3616 14.6667" stroke="#959DAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
												</div>
											</div>
											<div class="col-8 my-2" @click="toggleBackdrop('merchant')">
												<p class="mb-0 text-11 font-regular color-grey-ota">All Property</p>
              					<p class="mb-0 text-14 font-bold text-semi-dark">{{ $formatDateRange(filter_data.basic.check_in_date,filter_data.basic.check_out_date,'YYYY-MM-DD','YYYY-MM-DD') }} <svg class="mx-1" width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="2" height="2" rx="1" fill="#222"/></svg> {{ total_guests }}</p>
											</div>
											<div class="col-2 py-2">
												<div class="py-2 px-3 mr-2 d-table ml-auto border-semi-grey rounded-4 bg-grey-ota cursor-pointer" @click="toggleBackdrop('destination')">
													<svg width="18" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path fill-rule="evenodd" clip-rule="evenodd" d="M4.94423 2.53875C4.94423 3.88065 3.83797 4.9683 2.47212 4.9683C1.10706 4.9683 0 3.88065 0 2.53875C0 1.19763 1.10706 0.109985 2.47212 0.109985C3.83797 0.109985 4.94423 1.19763 4.94423 2.53875ZM13.2944 1.47453C13.8919 1.47453 14.3775 1.95165 14.3775 2.53863C14.3775 3.1264 13.8919 3.60352 13.2944 3.60352H8.56742C7.96916 3.60352 7.48353 3.1264 7.48353 2.53863C7.48353 1.95165 7.96916 1.47453 8.56742 1.47453H13.2944ZM1.0839 9.42517H5.81087C6.40913 9.42517 6.89477 9.90229 6.89477 10.4901C6.89477 11.077 6.40913 11.5549 5.81087 11.5549H1.0839C0.485637 11.5549 0 11.077 0 10.4901C0 9.90229 0.485637 9.42517 1.0839 9.42517ZM11.9056 12.8898C13.2715 12.8898 14.3777 11.8022 14.3777 10.4611C14.3777 9.11917 13.2715 8.03153 11.9056 8.03153C10.5405 8.03153 9.43349 9.11917 9.43349 10.4611C9.43349 11.8022 10.5405 12.8898 11.9056 12.8898Z" fill="#222222"/>
													</svg>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="px-7 w-100 bg-white position-absolute filter-header" :class="show_filter_top ? 'h-126 pb-3' : 'h-0'" style="top:74px;left:0xp;">
							<transition name="fade">
								<div class="row py-1 filter-header-child" v-show="backdrop_for != ''">
									<div class="col-12 mt-2">
										<MerchantFilter ref="merchant_filter" :backdrop="backdrop_for" :merchant_list="merchant_list" @toggleBackdrop="toggleBackdrop" @applyFilter="applyFilter"/>
									</div>
								</div>
							</transition>
						</div>
					</div>
				</header>

			


				<popup-detail 
        direction="right" 
        :show="responsive.mobile_header"
        :size="window.width >= 768 ? 25 : 100"
        title="Other Menu"
        @close="toggleMobileHeader">
	        <template v-slot:body>
		        <div class="px-4">
		        	<div class="d-block cursor-pointer py-3" @click="callClick">
		            <img 
		              src="../../assets/img/icon/menu-navbar/Calling.png" 
		              width="24"
		              :alt="community.name">
		              <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('restaurant.menu.call')}}</p>
		          </div>
		          <div class="py-3 cursor-pointer" @click="toggleBackdrop('cr_lang')">
								<svg width="24" height="24" class="mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12ZM15.9698 7.99994H18.9198C17.9598 6.34994 16.4298 5.06994 14.5898 4.43994C15.1898 5.54994 15.6498 6.74994 15.9698 7.99994ZM11.9998 4.04004C12.8298 5.24004 13.4798 6.57004 13.9098 8.00004H10.0898C10.5198 6.57004 11.1698 5.24004 11.9998 4.04004ZM4 12C4 12.69 4.1 13.36 4.26 14H7.64C7.56 13.34 7.5 12.68 7.5 12C7.5 11.32 7.56 10.66 7.64 9.99997H4.26C4.1 10.64 4 11.31 4 12ZM5.08008 16.0001H8.03008C8.35008 17.2501 8.81008 18.4501 9.41008 19.5601C7.57008 18.9301 6.04008 17.6601 5.08008 16.0001ZM5.08008 7.99999H8.03008C8.35008 6.74999 8.81008 5.54999 9.41008 4.43999C7.57008 5.06999 6.04008 6.33999 5.08008 7.99999ZM11.9998 19.96C11.1698 18.76 10.5198 17.43 10.0898 16H13.9098C13.4798 17.43 12.8298 18.76 11.9998 19.96ZM9.66 14H14.34C14.43 13.34 14.5 12.68 14.5 12C14.5 11.32 14.43 10.65 14.34 9.99997H9.66C9.57 10.65 9.5 11.32 9.5 12C9.5 12.68 9.57 13.34 9.66 14ZM14.5898 19.56C15.1898 18.45 15.6498 17.25 15.9698 16H18.9198C17.9598 17.65 16.4298 18.93 14.5898 19.56ZM16.5004 12C16.5004 12.68 16.4404 13.34 16.3604 14H19.7404C19.9004 13.36 20.0004 12.69 20.0004 12C20.0004 11.31 19.9004 10.64 19.7404 10H16.3604C16.4404 10.66 16.5004 11.32 16.5004 12Z" fill="#222222" fill-opacity="0.7"/>
								</svg>
								<p class="mb-0 font-semibold text-16 text-color-dark d-inline-block"><span>{{$t('hotel.language')}}</span> | {{getCurrency.code}}</p>
							</div>
		          <!-- <div v-if="isNotLogin" class="d-block cursor-pointer py-3">
	              <router-link :to="'/'+community.code+'/login'">
	                <img 
	                  src="../../assets/img/icon/menu-navbar/Login.png" 
	                  width="24"
	                  :alt="community.name">
	                <p class="mb-0 body-1-2 d-inline-block ml-1">{{$t('profile.login.login')}}</p>
	              </router-link>
	            </div>
	            <div class="mb-4 mt-3">
	              <router-link :to="'/'+community.code+'/login'" v-if="!isNotLogin">
	                <div class="my-auto text-center box-nav-desktop p-0 d-inline-block cursor-pointer" >
	                  <img :src="getCurrentUser.avatar" :alt="community.name" class="w-100 rounded-100 top-0 left-0 object-fit border-2-green" height="50" style="padding:1px">
	                </div>
	                <p class="mb-0 body-1-2 d-inline-block ml-1 width-profile-name text-truncate text-left">{{getCurrentUser.first_name}} {{getCurrentUser.last_name}}</p>
	              </router-link>
	            </div> -->
		        	<div class="mt-8 text-center">
								<p class="mb-2 font-semibold text-16 text-color-dark">{{community.address}}</p>
	            	<a :href="'tel:'+community.phone" target="_blank" class="color-black">
									<p class="mb-2 font-semibold text-16 text-color-dark"><u>{{community.phone}}</u></p>
								</a>
	              <a :href="'mailto:'+community.email" target="_blank" class="color-black">
									<p class="mb-2 font-semibold text-16 text-color-dark"><u>{{community.email}}</u></p>
								</a>
								<template>
			            <div class="mt-4">
			              <div class="d-inline-block mr-2 mb-2 footer-social-img" v-for="data in community.social_media">
			                <template v-if="data.type == 'WHATSAPP'">
			                	<a :href="data.account_url" target="_blank">
				                  <img src="../../assets/img/icon/social/whatsapp.svg" class="cursor-pointer social-img" width="35" title="Whatsapp">
				                  <img src="../../assets/img/icon/social/blur/whatsapp.svg" class="cursor-pointer social-img-blur" width="35" title="Whatsapp">
				                </a>
			                </template> 
			                <template v-if="data.type == 'FACEBOOK'">
			                	<a :href="data.account_url" target="_blank">
		                      <img src="../../assets/img/icon/social/facebook.svg" class="cursor-pointer social-img" width="35" title="Facebook">
		                      <img src="../../assets/img/icon/social/blur/facebook.svg" class="cursor-pointer social-img-blur" width="35" title="Facebook">
		                    </a> 
			                </template>
			                <template v-if="data.type == 'WEBSITE'">
			                	<a :href="data.account_url" target="_blank">
		                      <img src="../../assets/img/icon/social/website.svg" class="cursor-pointer social-img" width="35" title="Website">
		                       <img src="../../assets/img/icon/social/blur/website.svg" class="cursor-pointer social-img-blur" width="35" title="Website">
		                    </a> 
			                </template>
			                <template v-if="data.type == 'INSTAGRAM'">
			                	<a :href="data.account_url" target="_blank">
		                      <img src="../../assets/img/icon/social/instagram.svg" class="cursor-pointer social-img" width="35" title="Instagram">
				                  <img src="../../assets/img/icon/social/blur/instagram.svg" class="cursor-pointer social-img-blur" width="35" title="Instagram">
		                    </a> 
			                </template>
			                <template v-if="data.type == 'TIKTOK'">
			                	<a :href="data.account_url" target="_blank">
		                      <img src="../../assets/img/icon/social/tik-tok.svg" class="cursor-pointer social-img" width="35" title="Tiktok">
			                  	<img src="../../assets/img/icon/social/blur/tik-tok.svg" class="cursor-pointer social-img-blur" width="35" title="Tiktok">
		                    </a> 
			                </template>
			                <template v-if="data.type == 'TRIPADVISOR'">
			                	<a :href="data.account_url" target="_blank">
		                      <img src="../../assets/img/icon/social/tik-tok.svg" class="cursor-pointer social-img" width="35" title="Tiktok">
			                  	<img src="../../assets/img/icon/social/blur/tik-tok.svg" class="cursor-pointer social-img-blur" width="35" title="Tiktok">
		                    </a> 
			                </template>
			                <template v-if="data.type == 'YOUTUBE'">
			                	<a :href="data.account_url" target="_blank">
		                      <img src="../../assets/img/icon/social/tik-tok.svg" class="cursor-pointer social-img" width="35" title="Tiktok">
			                  	<img src="../../assets/img/icon/social/blur/tik-tok.svg" class="cursor-pointer social-img-blur" width="35" title="Tiktok">
		                    </a> 
			                </template>
			              </div>
			            </div>
			          </template>
							</div>
		        </div>
	        </template>
	      </popup-detail>


				<!-- FILTER & LIST -->
				<div class="row no-gutters">
					<div :class="{'col-lg-8':view_type=='with_map','col-12':view_type=='full'}">
						<div class="py-5" :class="{'px-6':view_type=='with_map','px-7':view_type=='full'}">

							<!-- LIST PROPERTY -->
							<div class="w-100">
								<p class="mb-1 font-bold text-22 text-semi-dark">Choose Your Destination</p>
								<p class="mb-0 font-regular color-grey-ga text-14">You are planning to stay {{ $formatDateWithoutMonth(filter_data.basic.check_in_date) }} to {{ $formatDateWithoutMonth(filter_data.basic.check_out_date) }}</p>

								<!-- CATEGORIES & ADVANCE FILTER BUTTON-->
								<!-- <div class="row mt-3">
									<div class="col-12 col-lg-9">
										<div class="py-2 cursor-pointer mr-4 d-inline-block" @click="selectDestination(des)" v-for="des in destination.list" :class="{'border-bottom-ota-2':destination.selected.id == des.id}">
											<p class="mb-0 font-sb-ota text-15 text-light-dark" :class="{'text-semi-dark font-bold':destination.selected.id == des.id}">{{des.name}}</p>
										</div>
									</div>
									<div class="col-12 col-lg-3 text-right align-self-center">
										<div class="d-inline-block cursor-pointer" @click="toggleAdvanceFilter()">
											<p class="mb-0 font-semibold d-inline-block mr-1">Filter</p>
											<svg width="15" :class="{'transform-180 delay':advance_filter.show}" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path fill-rule="evenodd" clip-rule="evenodd" d="M4.94423 2.53875C4.94423 3.88065 3.83797 4.9683 2.47212 4.9683C1.10706 4.9683 0 3.88065 0 2.53875C0 1.19763 1.10706 0.109985 2.47212 0.109985C3.83797 0.109985 4.94423 1.19763 4.94423 2.53875ZM13.2944 1.47453C13.8919 1.47453 14.3775 1.95165 14.3775 2.53863C14.3775 3.1264 13.8919 3.60352 13.2944 3.60352H8.56742C7.96916 3.60352 7.48353 3.1264 7.48353 2.53863C7.48353 1.95165 7.96916 1.47453 8.56742 1.47453H13.2944ZM1.0839 9.42517H5.81087C6.40913 9.42517 6.89477 9.90229 6.89477 10.4901C6.89477 11.077 6.40913 11.5549 5.81087 11.5549H1.0839C0.485637 11.5549 0 11.077 0 10.4901C0 9.90229 0.485637 9.42517 1.0839 9.42517ZM11.9056 12.8898C13.2715 12.8898 14.3777 11.8022 14.3777 10.4611C14.3777 9.11917 13.2715 8.03153 11.9056 8.03153C10.5405 8.03153 9.43349 9.11917 9.43349 10.4611C9.43349 11.8022 10.5405 12.8898 11.9056 12.8898Z" fill="#222222"/>
											</svg>
										</div>
									</div>
								</div> -->

								<!-- ADVANCE FILTER -->
								<transition name="fade">
									<MerchantAdvanceFilter 
										:backdrop="backdrop_for" 
										:destination="destination.list"
										:merchant_category="merchant_category_list" 
										:facility="facility_list"
										:default_filter="filter_data.advance" 
										@toggleBackdrop="toggleBackdrop" 
										@applyFilter="applyFilter" />
								</transition>

								<!-- MERCHANT LIST -->
								<div class="mt-4">
									<div class="w-100 bg-white fit-to-screen">
										<div v-if="merchant_room.is_load" class="py-5">
											<loader /> 
										</div>
										<template v-else> 
											<div v-if="merchant_room.error != ''" class="row justify-content-center">
												<div class="col-4">
													<ErrorMessage :message="merchant_room.error" />
												</div>
											</div>
											<template v-else>
												<template v-if="merchant_room.data.length == 0">
													<div class="text-center py-4 mb-2">
														<img src="../../assets/img/icon/404.png" width="200">
														<template>
															<p class="mb-1 mt-3 body-2-2 text-22 font-bold">{{$t('hotel.error.404')}}</p>
														</template>
														<p class="mb-3 body-2-2 font-semibold">{{$t('hotel.error.404-desc')}}</p>
													</div>
												</template>
												<div v-else class="row">
													<template v-for="merchant in merchant_room.data">
														<MerchantItem :data="merchant" @openDetail="goToDetailMerchant" @openDetailHome="openDetailHome" />
													</template>
												</div>
											</template>
										</template>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="bg-light-desktop">
      		<div class="footer">
						<div class="footer-bottom bg-light-page">
							<div class="px-7">
								<p class="font-regular text-14 mb-0 py-3 mobile-none">Copyright © {{year.getFullYear()}} {{community.name}} All Right Reserved 
									<span @click="toggleBackdrop('cr_lang')" class="mb-0 body-2-2 font-semibold  cursor-pointer float-right underline">
										<span>{{$t('hotel.language')}}</span> | {{getCurrency.name}} ({{getCurrency.code}})
									</span>
								</p>
								<div class="desktop-none py-3">
									<p class="font-regular text-14 mb-0">Copyright © {{year.getFullYear()}} {{community.name}} All Right Reserved 
									</p>
									<p @click="toggleBackdrop('cr_lang')" class="mb-0 body-2-2 text-14 font-semibold cursor-pointer underline">
										<span>{{$t('hotel.language')}}</span> | {{getCurrency.name}} ({{getCurrency.code}})
									</p>
								</div>
							</div>  
						</div>
					</div>
				</div>

				<CurrencyAndLanguage @close="toggleBackdrop" v-if="backdrop_for == 'cr_lang'"></CurrencyAndLanguage>

				<!-- PopUp Background -->
				<transition name="fade">
					<template v-if="backdrop_for != ''">
						<PopUpBackground 
							@handlePopupFilter="toggleBackdrop"></PopUpBackground>
					</template>
				</transition>
			</template>
		</template>
	</div>
</template>
<script type="text/javascript">
	import {get} from '@/services/index.js'
	import {mapGetters,mapMutations} from 'vuex'
	import MerchantFilter from '@/components/community/Filter'
	import MerchantAdvanceFilter from '@/components/community/AdvanceFilter'
	import MerchantItem from '@/components/community/MerchantItem'
	import CurrencyAndLanguage from '@/components/hotel/be/desktop/CurrencyAndLanguage';
	import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
	import currency from "@/data/currency"
	import moment from 'moment'

	export default{
		components:{
			MerchantFilter,
			MerchantAdvanceFilter,
			MerchantItem,
			CurrencyAndLanguage,
			PopUpBackground
		},	
		metaInfo(){
      return {
        title: this.community.name,
        titleTemplate: '',
				link: [
					{ rel: 'shortcut icon', href: this.community.favicon_url}
				],
      }
    },
		data(){
			return{
				is_load: false,
				error: '',
        year: new Date(),
				scrollPosition: null,
				community: {},
				currency:currency,
				merchant_list: [],
				merchant_room: {
					is_load: false,
					error: '',
					data: []
				},
				merchant_category_list: [],
				facility_list: [],
				destination:{
					list: [],
					selected: {}
				},
				backdrop_for: '',
				view_type: 'full',
				responsive:{
					mobile_header: false,
					mobile_filter: false
				},
				advance_filter:{
					show: false,
					data:{}
				},
				filter_data:{
					basic: {
						check_in_date: moment().format("YYYY-MM-DD"),
						check_out_date: moment().add(1,'d').format("YYYY-MM-DD"),
						promo_code: '',
						adult: 1,
						child: 0,
						infant: 0
					},
					advance:{
						destination_area_id: '',
						sort_by: 'room_type',
						language_code: 'en',
						device: this.$getDeviceType(),
						community_id: '',
						merchant_star: '',
						merchant_type_category: '',
						price_min: '',
						price_max: '',
						merchant_facility: []
					},
				},
				window: {
          width: 0
      	}
			}
		},
		computed:{
			...mapGetters(['getCurrency','getCurrentUser','isNotLogin']),
			community_code(){
				return this.$route.params.community_code
			},
			total_guests(){
				let total_guest = this.filter_data.basic.adult+this.filter_data.basic.child
				return `${total_guest} ${this.$pluralWord(total_guest,'Guest')}`
			},
			show_filter_top(){
				return !(this.backdrop_for == '' || this.backdrop_for == 'cr_lang' || this.backdrop_for == 'destination' || this.backdrop_for == 'star' || this.backdrop_for == 'type' || this.backdrop_for == 'price' || this.backdrop_for == 'facility') && !this.responsive.mobile_filter ? true : false
			}
		},	
		watch:{
			scrollPosition(){
				if(this.backdrop_for == 'merchant' || this.backdrop_for == 'date' || this.backdrop_for == 'guest'){
					this.toggleBackdrop()
				}
			}
		},
		mounted(){
			window.addEventListener('scroll', this.updateScroll);
			this.loadFirstData()
		},
		created(){
			window.addEventListener('resize', this.handleResize);
      this.handleResize();
		},
		destroyed(){
			window.removeEventListener('resize', this.handleResize);
		},
		methods:{
			...mapMutations([
				'setCurrency',
				'setBaseRate'
			]),
			// BASIC
			updateScroll() {
				this.scrollPosition = window.scrollY
			},
			toggleMobileViewFilter(){
				this.$smoothScroll('ota-header')
				this.$refs.merchant_filter.toggleMobileView()
			},
			toggleBackdrop(data=''){
				if(data == 'search-hit'){
					this.$refs.merchant_filter.hitSearch()
				}else{
					this.backdrop_for = data
					if(window.innerWidth <= 992){
						this.responsive.mobile_filter = true
					}else{
						this.responsive.mobile_filter = false
					}
				}
	    },
	    toggleMobileHeader(){
      	this.responsive.mobile_header = !this.responsive.mobile_header 
      },
      loadFirstData(){
      	this.is_load = true
      	this.error = ''
      	this.loadCommunityDetail().then(()=>{
      		Promise.all([
						this.setupCurrency(),
	      		this.loadMerchantList(),
	      		this.loadDestinationList(),
						this.loadMerchantCategoryList(),
						this.loadFacilityList()
	      	]).catch(err_all=>this.error = err_all).finally(()=>this.is_load=false)
      	}).catch(err=>{
      		this.error = err
      		this.is_load = false
      	})
      },
			setupCurrency(){
				return new Promise(done=>{
					let default_currency = 'IDR'
					
					if(Object.keys(this.getCurrency).length == 0 || Object.keys(this.getCurrency).length < 6 ){
						let selected_currency = this.currency.find(x=>x.code == default_currency)
						this.setCurrency(selected_currency)
						this.setBaseRate({a:1,b:1})
					}else{
						if(this.getCurrency.code != default_currency){
							this.$convertCurrency(this.getCurrency.code)
						}else{
							this.setBaseRate({a:1,b:1})
						}
					}
					done()
				})
			},
			customFormatDate(date,format){
				return moment(date).format(format)
			},
			applyFilter(data){
				if(data.merchant){
					this.filter_data.basic = {
						check_in_date: this.customFormatDate(data.date.startDate,'YYYY-MM-DD'),
						check_out_date: this.customFormatDate(data.date.endDate,'YYYY-MM-DD'),
						promo_code: data.promo_code,
						adult: data.guest.adult,
						child: data.guest.child,
						infant: data.guest.infant
					}
					if(data.merchant.id){
						this.goToDetailMerchant(data.merchant)
					}else{
						this.loadMerchantRoom()
					}
				}else{
					if(data.type == 'all'){
						this.filter_data.advance.destination_area_id = data.data.destination != 'all' ? data.data.destination : ''	
						this.filter_data.advance.merchant_star = data.data.star != 'all' ? data.data.star : ''
						this.filter_data.advance.merchant_type_category = data.data.type != 'all' ? data.data.type : ''
						this.filter_data.advance.price_min = data.data.price.min > 0 ? data.data.price.min : ''	
						this.filter_data.advance.price_max = data.data.price.max > 0 ? data.data.price.max : ''	
						this.filter_data.advance.merchant_facility = data.data.facility.length > 0 ? data.data.facility.map(x=>x.id) : ''
					}
					if(data.type == 'destination'){
						this.filter_data.advance.destination_area_id = data.data != 'all' ? data.data : ''	
					}
					if(data.type == 'star'){
						this.filter_data.advance.merchant_star = data.data != 'all' ? data.data : ''	
					}
					if(data.type == 'type'){
						this.filter_data.advance.merchant_type_category = data.data != 'all' ? data.data : ''	
					}
					if(data.type == 'price'){
						this.filter_data.advance.price_min = data.data.min > 0 ? data.data.min : ''	
						this.filter_data.advance.price_max = data.data.max > 0 ? data.data.max : ''	
					}
					if(data.type == 'facility'){
						this.filter_data.advance.merchant_facility = data.data.length > 0 ? data.data.map(x=>x.id) : ''	
					}
					this.loadMerchantRoom()
				}
			},
			goToDetailMerchant(merchant,is_home=false){
				let params = `hotel-filter-redirect/${this.filter_data.basic.check_in_date}/${this.filter_data.basic.check_out_date}`
				if(this.filter_data.basic.promo_code != ''){
					params += `/${this.filter_data.basic.promo_code}`
				}else{
					params += '/promo_code_empty'
				}
				params += `?guest=${this.filter_data.basic.adult}-${this.filter_data.basic.child}-${this.filter_data.basic.infant}`
				if(is_home){
					params += `&is_home=true`
				}
				let merchant_url = `${window.location.origin}/${merchant.code}/${params}`
				window.open(merchant_url,'_blank')
			},
			formatDateSort(date){
				return moment(date,'YYYY-MM-DD').format('D MMM')
			},
			openDetailHome(merchant){
				this.goToDetailMerchant(merchant,true)
			},

      // API
      loadCommunityDetail(){
      	return new Promise((success,fail)=>{
      		get('COMMUNITY',`community/${this.community_code}`).then(response=>{
      			let res = response.data
      			if(res.success){
      				this.community = res.data
      				success()
      			}else{
      				fail(res.message)
      			}
      		})
      	})
      },
      loadMerchantList(){
      	return new Promise((success,fail)=>{
      		get('COMMUNITY','merchant-list',{
      			community_id: this.community.id,
      			merchant_type:  'hotel'
      		}).then(response=>{
      			let res = response.data
      			if(res.success){
      				this.merchant_list = res.data
      				success()
      			}else{
      				fail(res.message)
      			}
      		})
      	})
      },
      loadDestinationList(){
      	return new Promise((success,fail)=>{
      		get('COMMUNITY',`community/${this.community.id}/destination-area`).then(response=>{
      			let res = response.data
      			if(res.success){
      				this.destination.list = res.data
      				this.destination.list.unshift({
      					id: 'all',
      					name: 'All Regional'
      				})
      				this.destination.selected = this.destination.list[0]
      				success()
      			}else{
      				fail(res.message)
      			}
      		})
      	})
      },
      loadMerchantCategoryList(){
      	return new Promise((success,fail)=>{
      		get('COMMUNITY','merchant-category-list',{
      			community_id: this.community.id,
      			merchant_type:  'hotel'
      		}).then(response=>{
      			let res = response.data
      			if(res.success){
      				this.merchant_category_list = res.data
							this.merchant_category_list.unshift({
      					id: 'all',
      					name: 'All type'
      				})
      				success()
      			}else{
      				fail(res.message)
      			}
      		})
      	})
      },
			loadFacilityList(){
      	return new Promise((success,fail)=>{
      		get('COMMUNITY','merchant-facility-list',{
      			community_id: this.community.id,
      			merchant_type:  'hotel'
      		}).then(response=>{
      			let res = response.data
      			if(res.success){
      				this.facility_list = res.data.map(x=>{
								let return_data = {
									selected: false,
									...x
								}
								return return_data
							})
      				success()
      			}else{
      				fail(res.message)
      			}
      		})
      	})
      },
			loadMerchantRoom(){
				if(this.community.id){
					this.$smoothScroll('ota-header')
					this.merchant_room.is_load = true
					this.merchant_room.error = ''
					let params = {
						...this.filter_data.basic, 
						...this.filter_data.advance
					}
					params.community_id = this.community.id
					get("COMMUNITY","hotel/search-room",params).then(response=>{
						let res = response.data
						if(res.success){
							this.merchant_room.data = res.data
						}else{
							this.merchant_room.error = res.message
						}
						this.merchant_room.is_load = false
					})
				}
			},
			callClick(){
				this.$postLog('HOME','NAVBAR','Clicked menu call')
      	setTimeout(()=>{
      		let tag_a = document.createElement('a')
      		tag_a.href = `tel:${this.community.phone}`
      		tag_a.click()
      		tag_a.remove()
      	},300)
			},
			handleResize() {
        this.window.width = window.innerWidth;
      },
      maskingPlusChar(data){
        let return_data = data.substring(0,1)
        return return_data == '+' ? data.substring(1,data.length) : data
      },
		}
	}
</script>
<style scoped>
	.custom-divider{
		height: 50px;
		width: 1px;
		margin: 0px 18px;
		background-color: #DDDDDD;
	}
	.filter-header{
		transition: 0.3s ease-in-out;
	}
	.filter-header-child{
		transition: 0.6s ease-in-out;
	}
	.h-0{
		height: 0px;
		overflow: hidden;
	}
	.h-126{
		height: 126px;
	}
	.mw-80{
		max-width: 80%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/community/Home.vue